import type { DesignCapabilityProviderRegistry } from './contracts';
import { NEUTRAL_DESIGN_CAPABILITY_CATALOG } from './neutralCatalog';
import { NEUTRAL_CAPABILITY_RENDERERS } from './neutralRenderers';
import { compileDesignCapabilityRuntime } from './runtime';

export const NEUTRAL_CAPABILITY_PROVIDERS = Object.freeze(
  Object.fromEntries(
    NEUTRAL_DESIGN_CAPABILITY_CATALOG.entries.map(({ provider }) => [
      provider.providerId,
      Object.freeze({
        providerId: provider.providerId,
        ...(provider.sideEffectAdapterRef
          ? { sideEffectAdapterId: provider.sideEffectAdapterRef.id }
          : {}),
      }),
    ]),
  ),
) as DesignCapabilityProviderRegistry;

export const NEUTRAL_DESIGN_CAPABILITY_RUNTIME =
  compileDesignCapabilityRuntime({
    catalog: NEUTRAL_DESIGN_CAPABILITY_CATALOG,
    providers: NEUTRAL_CAPABILITY_PROVIDERS,
    renderers: NEUTRAL_CAPABILITY_RENDERERS,
  });
